import React from 'react';
import { Button, Typography, Row, Col, Card } from 'antd';
import { PhoneOutlined, MailOutlined, ClockCircleOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { shopConfig } from '../../config/shop.config';

const { Title, Text, Paragraph } = Typography;

const ContactSection: React.FC = () => {
  const handleCallClick = () => {
    window.location.href = `tel:${shopConfig.phone}`;
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${shopConfig.email}`;
  };

  return (
    <div id="contact" style={{ padding: '80px 20px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={2}>Get In Touch</Title>
          <Paragraph style={{ fontSize: '18px', color: '#6b7280', maxWidth: '600px', margin: '0 auto' }}>
            Call us today for expert automotive service and honest pricing
          </Paragraph>
        </div>

        {/* Contact Cards */}
        <Row gutter={[32, 32]} style={{ marginBottom: '48px' }}>
          {/* Phone */}
          <Col xs={24} md={12}>
            <Card
              style={{
                height: '100%',
                borderRadius: '12px',
                border: '2px solid #e5e7eb',
                textAlign: 'center',
              }}
            >
              <PhoneOutlined style={{ fontSize: '48px', color: '#2563eb', marginBottom: '16px' }} />
              <Title level={4} style={{ marginBottom: '8px' }}>
                Call Us
              </Title>
              <Text style={{ fontSize: '24px', fontWeight: 600, color: '#2563eb', display: 'block', marginBottom: '16px' }}>
                {shopConfig.cta.phoneDisplay}
              </Text>
              <Button
                type="primary"
                size="large"
                icon={<PhoneOutlined />}
                onClick={handleCallClick}
                style={{ width: '100%', maxWidth: '300px', height: '50px', fontSize: '16px' }}
              >
                Call Now
              </Button>
            </Card>
          </Col>

          {/* Email */}
          <Col xs={24} md={12}>
            <Card
              style={{
                height: '100%',
                borderRadius: '12px',
                border: '2px solid #e5e7eb',
                textAlign: 'center',
              }}
            >
              <MailOutlined style={{ fontSize: '48px', color: '#10b981', marginBottom: '16px' }} />
              <Title level={4} style={{ marginBottom: '8px' }}>
                Email Us
              </Title>
              <Text style={{ fontSize: '18px', color: '#4b5563', display: 'block', marginBottom: '16px' }}>
                {shopConfig.email}
              </Text>
              <Button
                size="large"
                icon={<MailOutlined />}
                onClick={handleEmailClick}
                style={{ width: '100%', maxWidth: '300px', height: '50px', fontSize: '16px' }}
              >
                Send Email
              </Button>
            </Card>
          </Col>
        </Row>

        {/* Business Info */}
        <Row gutter={[32, 32]}>
          {/* Hours */}
          <Col xs={24} md={12}>
            <div style={{ textAlign: 'center', padding: '24px' }}>
              <ClockCircleOutlined style={{ fontSize: '36px', color: '#6b7280', marginBottom: '16px' }} />
              <Title level={4} style={{ marginBottom: '16px' }}>
                Business Hours
              </Title>
              <div>
                <Text style={{ display: 'block', fontSize: '15px', color: '#4b5563', marginBottom: '4px' }}>
                  Weekdays: {shopConfig.hours.weekday}
                </Text>
                <Text style={{ display: 'block', fontSize: '15px', color: '#4b5563', marginBottom: '4px' }}>
                  Saturday: {shopConfig.hours.saturday}
                </Text>
                <Text style={{ display: 'block', fontSize: '15px', color: '#4b5563' }}>
                  Sunday: {shopConfig.hours.sunday}
                </Text>
              </div>
            </div>
          </Col>

          {/* Location */}
          <Col xs={24} md={12}>
            <div style={{ textAlign: 'center', padding: '24px' }}>
              <EnvironmentOutlined style={{ fontSize: '36px', color: '#6b7280', marginBottom: '16px' }} />
              <Title level={4} style={{ marginBottom: '16px' }}>
                Location
              </Title>
              <div>
                <Text style={{ display: 'block', fontSize: '15px', color: '#4b5563', marginBottom: '4px' }}>
                  {shopConfig.address.street}
                </Text>
                <Text style={{ display: 'block', fontSize: '15px', color: '#4b5563' }}>
                  {shopConfig.address.city}, {shopConfig.address.state} {shopConfig.address.zip}
                </Text>
              </div>
            </div>
          </Col>
        </Row>

        {/* CTA Banner */}
        <div
          style={{
            marginTop: '48px',
            padding: '40px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '16px',
            textAlign: 'center',
            color: 'white',
          }}
        >
          <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
            {shopConfig.cta.primary}
          </Title>
          <Paragraph style={{ fontSize: '18px', color: 'rgba(255, 255, 255, 0.9)', marginBottom: '24px' }}>
            Professional automotive repair and maintenance you can trust
          </Paragraph>
          <Button
            type="primary"
            size="large"
            icon={<PhoneOutlined />}
            onClick={handleCallClick}
            style={{
              height: '56px',
              fontSize: '18px',
              fontWeight: 600,
              padding: '0 40px',
              backgroundColor: '#10b981',
              borderColor: '#10b981',
              borderRadius: '28px',
            }}
          >
            {shopConfig.cta.phoneDisplay}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
